const corporationReadFileToken =
  process.env.REACT_APP_AZURE_READ_CORPORATION_FILE || "";

export const getClientLogoSrc = (logoUrl) => {
  if (!logoUrl || logoUrl === "NaN") return null;
  return `${logoUrl}${corporationReadFileToken}`;
};

const lettersOnly = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/[^\p{L}]/gu, "");

export const getClientInitials = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .map(lettersOnly)
    .filter((part) => part.length > 0);

  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

export const formatClientAddressDisplay = (address) => {
  const normalized = String(address ?? "").trim();
  if (
    !normalized ||
    normalized === " " ||
    [undefined, "undefined"].includes(normalized)
  ) {
    return "—";
  }
  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
};

/** Maquette : « Créé le : 13 octobre, 2025 » */
export const formatClientCreatedDate = (date, locale = "fr-FR") => {
  if (!date) return "—";
  try {
    const formatted = new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(new Date(date));
    return formatted;
  } catch {
    return "—";
  }
};

export const buildClientLogoBlobName = (corporationId, clientId, fileName) => {
  const safeName = String(fileName || "logo.png").replace(
    /[^a-zA-Z0-9._-]/g,
    "_",
  );
  return `${corporationId}/clients/${clientId}/${safeName}`;
};

/** Affichage maquette historique : site (ligne 1) + zone ou positionnement (ligne 2). */
export const getZoneDisplayLines = (zone) => {
  const siteName = zone?.addressName || zone?.name || "—";
  let subLabel = "";
  if (zone?.positioning) {
    const pos = String(zone.positioning);
    subLabel = `${pos.charAt(0).toUpperCase()}${pos.slice(1)}`;
  } else if (
    zone?.name &&
    zone?.addressName &&
    String(zone.name) !== String(zone.addressName)
  ) {
    subLabel = zone.name;
  }
  return { siteName, subLabel };
};

export const readFileAsBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

/**
 * Même objet super-conteneur que sur /characterization/list (export PDF + photos).
 * Référence : CharacterizationRow → exportPdfFromRow.
 */
/** Zoom appliqué sur #root (Paramètres) — le portail body doit le reproduire pour un menu identique à la liste carac. */
export const getAppZoom = () => {
  const root = document.getElementById("root");
  if (!root) return 1;
  const zoom = parseFloat(getComputedStyle(root).zoom);
  return Number.isFinite(zoom) && zoom > 0 ? zoom : 1;
};

export const resolveSuperContainerForExport = (
  superContainerId,
  superContainers = [],
) => {
  if (!superContainerId) return null;
  return (
    superContainers.find((s) => String(s._id) === String(superContainerId)) ?? {
      _id: superContainerId,
    }
  );
};
